/*
 *  -----------------------------------------------------------------------
 *    <copyright file="assign-svt-assessment.helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import i18next from 'i18next';
import { StudyAssessmentFields } from '@queries/generated/fragments.generated';

export const formAssessmentAttributes = (assessment: StudyAssessmentFields) => {
    const keys: (keyof StudyAssessmentFields)[] = ['endPoint', 'safety', 'lab', 'sendToVendor'];
    const attributes: string[] = [];

    keys.forEach((key) => {
        if (assessment[key]) {
            attributes.push(i18next.t(`admin:${key}`));
        }
    });

    return attributes.join(', ');
};
